<p-toast></p-toast>
<p-dialog
  [(visible)]="display"
  [style]="{ width: '35vw' }"
  (onHide)="reloadDocumentDetail()"
  [modal]="true"
  id="requestEffectiveDateModal"
>
  <ng-template pTemplate="header"> Requested Effective Date </ng-template>
  <p>
    {{effectiveDateModalText}}
  </p>
  <div class="mt-2">
    <bpt-datetime
      appendTo="'body'"
      id="requestedEffectiveDate"
      [minDate]="minDateValue.toString()"
      placeholder="Enter or select a date"
      label="Requested Effective Date"
      [(ngModel)]="selectedRequestEffectiveDate"
    ></bpt-datetime>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="Save"
      type="submit"
      id="saveRequestedEffectiveDateButton"
      class="align-right"
      (debounceClick)="saveDate()"
    >
    </p-button>
  </ng-template>
</p-dialog>
